<template>
    <div>
        TimeTracking
    </div>
</template>

<script>
    export default {
        name: "TimeTracking"
    }
</script>

<style scoped>

</style>